import React, { useState, useEffect } from "react";
import "./style.css";
import Pageloader from "../../../components/loader";
import {
  MinusCircleOutlined,
  PlusOutlined,
  RollbackOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import {
  Typography,
  Button,
  Form,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { getBatchList } from "../../../services/batch.service";
import { getZoneList } from "../../../services/zone.service";
import { shiftAdd, getShiftTypes } from "../../../services/shift.service";
import moment from "moment";
import { swalNotification } from "../../../components/alret/notificztion";
import { validationErrors } from "../../../utils/Helpers";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const Shiftcreate = () => {
  const pagename = "Shift";
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [zoneData, setZoneData] = useState(null);
  const [shiftTypesData, setShiftTypesData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [errMsg, setErrMsg] = useState(null);
  // useEffect(() => {
  //   if (postData) {
  //     setErrMsg(null);
  //   }
  // }, [postData]);
  // useEffect(() => {
  //   if (errMsg) {
  //     setPostData(null);
  //     setZoneData(null);
  //   }
  // }, [errMsg]);
  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      const resp = await getBatchList();
      setPostData(resp.data.data);
      const zones = await getZoneList();
      setZoneData(zones.data.data);
      const shiftTypes = await getShiftTypes();
      setShiftTypesData(shiftTypes.data.data);
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    const newData = values;
    let shift_duration = moment.duration(
      moment(newData.endTime._d).diff(moment(newData.startTime._d))
    );
    newData.startTime = moment(values.startTime).format("X");
    newData.shiftDuration = shift_duration.asHours().toFixed(1);
    if (shift_duration < 0) {
      swalNotification(
        "Start and End time Issue",
        "End time must be greater than start time",
        "error"
      );
      return null;
    }
    if (newData.batchList === undefined || newData.batchList.length < 1) {
      swalNotification(
        "Single Shift Add",
        "Please add atleast 1 Batch",
        "error"
      );
      return null;
    }
    let batchTotalSlots = 0;
    newData.batchList.map((v, i) => {
      batchTotalSlots += v.maxSlots;
    });
    if (batchTotalSlots < newData.totalSlots) {
      swalNotification(
        "Validation Errors",
        "Slots Quota must be greater than OR equal to total slots",
        "error"
      );
      return null;
    }
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const resp = await shiftAdd(newData);
      if (resp.data.code == 200) {
        swalNotification("Single Shift Add", resp.data.message, "success");
        postLists();
      }
    } catch (error) {
      validationErrors(error);
    }
  };
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };
  const disabledDate = (current) => {
    return current && current < moment();
  };

  const disabledDateTime = () => ({
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  });

  // const [data, setData] = useState([]);
  // const [prevKey, setPrevKey] = useState(null);
  // const [optionsSelected, setOptionsSelected] = useState([]);
  // let optionValues = [];

  const handleOnValuesChange = (key, val, name) => {
    const updating = [...postData];
    postData.map((d, i) => {
      if (d.batch.id === val.value) {
        updating[i] = {
          ...d,
          index: key,
          disabled: true,
        };
      }
      if (key === d.index) {
        updating[i] = {
          ...d,
          disabled: false,
        };
      }
    });
    setPostData(updating);
  };

  const removeCustom = (value) => {
    const updating = [...postData];
    postData.map((d, i) => {
      if (d.index === value) {
        updating[i] = {
          ...d,
          disabled: false,
          index: "",
        };
      }
    });
    setPostData(updating);
  };

  const [totalSlotsVal, setTotalSlotsVal] = useState(1);
  const handleTotalSlotsChange = (value) =>{
    setTotalSlotsVal(value)
  }
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename} Add</Title>
        </div>
        <div className="pch-content">
          <Button onClick={() => navigate("/shifts")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      {loading ? (
          <Pageloader />
        ) : 
      <Form onFinish={onFinish}>
        <div className="customTable">
          <table>
            <thead>
            <tr>
              <th>Zone</th>
              <th>Start Date Time</th>
              <th>End Date Time</th>
              <th>Total Slots</th>
              <th>Shift Types</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <Form.Item
                    name={"zone"}
                    rules={[{required: true, message: "Zone is Required"}]}
                >
                  <Select
                      showSearch
                      placeholder="Select a Zone"
                      optionFilterProp="children"
                  >
                    {zoneData &&
                        zoneData.map((zone) => {
                          return (
                              <Select.Option key={zone.id} value={zone.id}>
                                {zone.zoneName}
                              </Select.Option>
                          );
                        })}
                  </Select>
                </Form.Item>
              </td>
              <td>
                <Form.Item
                    name={"startTime"}
                    rules={[
                      {
                        required: true,
                        message: "Please add start date time",
                      },
                    ]}
                >
                  <DatePicker
                      format="YYYY-MM-DD HH:mm:ss"
                      disabledDate={disabledDate}
                      showTime={{
                        defaultValue: moment("00:00:00", "HH:mm:ss"),
                      }}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                    name={"endTime"}
                    rules={[
                      {
                        required: true,
                        message: "Please add end date time",
                      },
                    ]}
                >
                  <DatePicker
                      format="YYYY-MM-DD HH:mm:ss"
                      disabledDate={disabledDate}
                      showTime={{
                        defaultValue: moment("00:00:00", "HH:mm:ss"),
                      }}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                    name={"totalSlots"}
                    rules={[
                      {
                        required: true,
                        message: "Please add total number of slots",
                      },
                    ]}
                >
                  <InputNumber
                      onChange={handleTotalSlotsChange}
                      placeholder="Total Slots"
                      min={1}
                      formatter={(value) => `${value}`}
                      parser={(value) => value.replace(".", "")}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                    name={"type"}
                    rules={[{required: true, message: 'Shift Type is required'}]}
                >
                  <Select
                      showSearch
                      placeholder="Select a Shift Type"
                      optionFilterProp="children"
                  >
                    {shiftTypesData &&
                        shiftTypesData.map((shiftType) => {
                          return (
                              <Select.Option key={shiftType} value={shiftType}>
                                {shiftType}
                              </Select.Option>
                          );
                        })}
                  </Select>
                </Form.Item>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Form.List name={"batchList"}>
          {(fields, {add, remove}) => (
              <div className="customTable">
                <table>
                  <thead>
                  <tr>
                    <th>Batch</th>
                    <th>Slots Quota</th>
                    <th>Show Time(Hours)</th>
                    <th>Expiry Time(Hours)</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  {fields.map((field, index) => {
                    return (
                        <tr key={field.key}>
                          <td>
                            <Form.Item
                                key={field.key}
                                name={[field.name, "batchId"]}
                            rules={[
                              {
                                required: true,
                                message: "Batch Level is Required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Batch"
                              onChange={(key, val, name) =>
                                handleOnValuesChange(field.key, val, fields)
                              }
                            >
                              {postData.map((b, i) => {
                                return (
                                  <Select.Option
                                    key={b.batch.id}
                                    value={b.batch.id}
                                    disabled={b.disabled}
                                  >
                                    {b.batch.batchLevel}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "maxSlots"]}
                            initialValue={totalSlotsVal}
                            rules={[
                              {
                                required: true,
                                message: "Slots is Required",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Slots Quota"
                              min={1}
                              formatter={(value) => `${value}`}
                              parser={(value) => value.replace(".", "")}
                            />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "startDisplayHours"]}
                            initialValue="0.01"
                            rules={[
                              {
                                required: true,
                                message: "Show Time is Required",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Show Time(Hours)"
                              min={0.01}
                              prefix={<ClockCircleOutlined />}
                            />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "endDisplayHours"]}
                            initialValue="0.01"
                            rules={[
                              {
                                required: true,
                                message: "Expiry Time is Required",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Expiry Time(Hours)"
                              min={0.01}
                              prefix={<ClockCircleOutlined />}
                            />
                          </Form.Item>
                        </td>
                        <td>
                          <MinusCircleOutlined
                            style={{ height: 40, color: "red" }}
                            onClick={() => {
                              remove(field.name);
                              removeCustom(field.key);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {fields.length > 5 ? (
                    ""
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <Form.Item>
                          <Button
                            icon={<PlusOutlined />}
                            onClick={() => {
                              add();
                            }}
                            style={{ maxWidth: "250px" }}
                          >
                            Add a Batch
                          </Button>
                        </Form.Item>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Form.List>
        <Form.Item>
          <Button className="submit" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
      }
    </div>
  );
};
export default Shiftcreate;
